# import AmortizationActionItemResponseFragment from "../fragments/amortization-action-item-response.graphql"

mutation CreateAmortizationActionItemResponse(
  $data: AmortizationActionItemResponseInput!
) {
  createAmortizationActionItemResponse(data: $data) {
    ...AmortizationActionItemResponseFragment
  }
}
